import { DEFAULT_LOCALE } from '@unreserved-frontend-v2/utils/locale'
import { Translate } from 'next-translate'

// TODO: Potentially don't need to export this anymore
const SQUARE_FT_VALUES = [
  {
    key: 'squareFootageGTE',
    values: [
      750, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2250, 2500, 2750, 3000, 4000, 5000, 7500,
      10000,
    ],
  },
  {
    key: 'squareFootageLTE',
    values: [
      750, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2250, 2500, 2750, 3000, 4000, 5000, 7500,
      10000,
    ],
  },
]

// Simple utility to map sqft `key` into their translated names
export const getSqFtValues = (translate: Translate) => {
  return SQUARE_FT_VALUES.map((group) => ({
    ...group,
    suffixRemovalStr: translate('listings:sqft', { sqft: '' }),
    values: group.values.map((value) => ({
      value,
      key: translate('listings:sqft', { sqft: value.toLocaleString(DEFAULT_LOCALE) }),
    })),
  }))
}

export const getPriceValues = (gteKey: string, lteKey: string) => {
  return [
    {
      key: gteKey,
      values: [
        { key: '$100k', value: 100000 },
        { key: '$200k', value: 200000 },
        { key: '$300k', value: 300000 },
        { key: '$400k', value: 400000 },
        { key: '$500k', value: 500000 },
        { key: '$600k', value: 600000 },
        { key: '$700k', value: 700000 },
        { key: '$800k', value: 800000 },
        { key: '$900k', value: 900000 },
        { key: '$1M', value: 1000000 },
        { key: '$1.25M', value: 1250000 },
        { key: '$1.5M', value: 1500000 },
        { key: '$1.75M', value: 1750000 },
        { key: '$2M', value: 2000000 },
        { key: '$2.25M', value: 2250000 },
        { key: '$2.5M', value: 2500000 },
        { key: '$2.75M', value: 2750000 },
        { key: '$3M', value: 3000000 },
        { key: '$3.25M', value: 3250000 },
        { key: '$3.5M', value: 3500000 },
        { key: '$3.75M', value: 3750000 },
        { key: '$4M', value: 4000000 },
        { key: '$4.25M', value: 4250000 },
        { key: '$4.5M', value: 4500000 },
        { key: '$4.75M', value: 4750000 },
        { key: '$5M', value: 5000000 },
        { key: '$6M', value: 6000000 },
        { key: '$7M', value: 7000000 },
        { key: '$8M', value: 8000000 },
        { key: '$9M', value: 9000000 },
        { key: '$10M', value: 10000000 },
      ],
    },
    {
      key: lteKey,
      values: [
        { key: '$100k', value: 100000 },
        { key: '$200k', value: 200000 },
        { key: '$300k', value: 300000 },
        { key: '$400k', value: 400000 },
        { key: '$500k', value: 500000 },
        { key: '$600k', value: 600000 },
        { key: '$700k', value: 700000 },
        { key: '$800k', value: 800000 },
        { key: '$900k', value: 900000 },
        { key: '$1M', value: 1000000 },
        { key: '$1.25M', value: 1250000 },
        { key: '$1.5M', value: 1500000 },
        { key: '$1.75M', value: 1750000 },
        { key: '$2M', value: 2000000 },
        { key: '$2.25M', value: 2250000 },
        { key: '$2.5M', value: 2500000 },
        { key: '$2.75M', value: 2750000 },
        { key: '$3M', value: 3000000 },
        { key: '$3.25M', value: 3250000 },
        { key: '$3.5M', value: 3500000 },
        { key: '$3.75M', value: 3750000 },
        { key: '$4M', value: 4000000 },
        { key: '$4.25M', value: 4250000 },
        { key: '$4.5M', value: 4500000 },
        { key: '$4.75M', value: 4750000 },
        { key: '$5M', value: 5000000 },
        { key: '$6M', value: 6000000 },
        { key: '$7M', value: 7000000 },
        { key: '$8M', value: 8000000 },
        { key: '$9M', value: 9000000 },
        { key: '$10M', value: 10000000 },
      ],
    },
  ]
}
